import React from "react";
import CtaBanner from "../components/Main/CtaBanner";
import Page from "../components/Page";
import RowList from "../components/Main/RowList";
import Vignette from "../components/Main/Vignette";
import { ImageGallery } from "../components/Main/ImageGallery";
import { ImgAndCopy } from "../components/Main/ImgAndCopy";
import { HeadingAndCopy } from "../components/Main/HeadingAndCopy";
import { EventsList } from "../components/Main/EventsList";
import ImageCallout from "../components/Main/ImageCallout";

export default function EventsAlt(props) {
  const {
    //Hero Section fields
    intro_image: {
      url: introImage,
      alt: alt,
      height: height,
      width: width,
      id: imageId,
    },
    intro_heading: introHeading,
    intro_paragraph: introParagraph,
    image_side: imageSide,

    // Callout Middle (top copy)
    //callout_about_image: ,
    callout_about_image_caption: aboutCaption,
    callout_about_heading: aboutHeading,
    callout_about_sub_heading: aboutSubheading,
    callout_about_paragraph: aboutParagraph,
    callout_about_link: {
      url: aboutUrl,
      title: aboutLinkTitle,
      target: aboutLinkTarget,
    },
    callout_about_column_order: aboutColOrder,
    intro_link_icon: aboutIcon,

    //Callout Lower
    callout_lower_image: { url: lowerImageUrl },
    callout_lower_image_caption: lowerCaption,
    callout_lower_heading: lowerHeading,
    callout_lower_sub_heading: lowerSubheading,
    callout_lower_paragraph: lowerParagraph,
    callout_lower_link: { url: lowerUrl, title: lowerLinkTitle },
    callout_lower_column_order: lowerColOrder,
    intro_link_icon: lowerIcon,

    //Events Repeater
    events_heading: eventsHeading,
    events: eventsFields,

    // Image and Copy Section
    img_section_heading: imgSctnHeading,
    img_section_copy: imgSctnCopy,
    img_section_image: imgSctnImage,

    //Vignette fields
    vignette_heading: vignetteHeading,
    vignette_link: vignetteLink,
    vignette_copy: vignetteCopy,
    vignette_video: vignetteVideos,

    // Image Grid
    imggrid_heading: imgGridHeading,
    imggrid_copy: imgGridCopy,
    imggrid_gallery: imgGridImages,
  } = props.acf;

  return (
    <React.Fragment>
      {/* Page defines hero */}
      <Page
        title={introHeading}
        body={introParagraph}
        bgImage={introImage}
        centered
        lgHeading
        bgId={imageId}
        alt={alt}
        height={height}
        width={width}
        disableArrow
      >
        <main
          id="content"
          className="events-page tw-flex tw-flex-col tw-gap-52 tw-pb-60 tw-items-center"
        >
          {/* Upper Copy */}
          {(aboutHeading || aboutParagraph) && (
            <HeadingAndCopy
              heading={aboutHeading}
              paragraph={aboutParagraph}
              className={"tw-w-[90%] md:tw-w-2/3 tw-pt-20"}
            />
          )}

          {/* Lower Callout */}
          {lowerHeading && (
            <ImageCallout
              reversed
              title={lowerHeading}
              body={lowerParagraph}
              link={lowerUrl}
              button={lowerLinkTitle}
              image={lowerImageUrl}
            />
          )}

          {/* Events */}
          {eventsFields && (
            <EventsList
              heading={eventsHeading}
              eventsFields={eventsFields}
              className="min-[992px]:-tw-mt-60"
            />
          )}

          {/* Image Section */}
          {(imgSctnHeading || imgSctnCopy || imgSctnImage) && (
            <ImgAndCopy
              image={imgSctnImage}
              heading={imgSctnHeading}
              copy={imgSctnCopy}
              className="tw-w-[90%] md:tw-w-2/3"
            />
          )}

          {/* Vignettes */}
          {vignetteVideos && (
            <Vignette
              heading={vignetteHeading}
              copy={vignetteCopy}
              videos={vignetteVideos}
              linkUrl={vignetteLink.url}
              linkText={vignetteLink.title}
              target={vignetteLink.title}
              className="tw-w-[90%] md:tw-w-2/3"
            />
          )}

          {/* Image Gallery */}
          {(imgGridHeading || imgGridCopy || imgGridImages) && (
            <ImageGallery
              heading={imgGridHeading}
              copy={imgGridCopy}
              gridImages={imgGridImages}
              className="tw-w-[90%] md:tw-w-2/3"
            />
          )}
        </main>
      </Page>
    </React.Fragment>
  );
}
